import styled, { css } from "styled-components";

import {
  Accordion,
  Grid,
  IconButton,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";

const white = (props) => props.theme.palette.white;
const gray = (props) => props.theme.palette.gray;
const grayLight = (props) => props.theme.palette.light.gray;

const montserrat = (props) => props.theme.fonts.montserrat;

export const ContainerIcon = styled.div`
  ${(props) =>
    props.containerHeight &&
    css`
      height: ${(props) => props.containerHeight}px;
    `};

  .MuiSvgIcon-root {
    color: ${(props) => props.theme.palette[props.iconColor || "black"]};
    ${(props) =>
      props.border &&
      css`
        border: ${(props) => props.border};
      `};

    ${(props) =>
      props["border-radius"] &&
      css`
        border-radius: ${(props) => props["border-radius"]}px;
      `};

    ${(props) =>
      props.fontSize &&
      css`
        font-size: ${(props) => props.fontSize}px;
      `};

    cursor: ${(props) => props.cursor || "pointer"};

    :hover {
      color: ${(props) =>
        props.theme.palette[
          props.iconHoverColor || props.iconColor || "black"
        ]};
    }
  }
`;

export const Padding = styled.div`
  ${(props) =>
    props.padding &&
    css`
      padding: ${(props) => props.padding.replace(/( )+/g, "px ")}px;
    `};

  ${(props) =>
    props.top &&
    css`
      padding-top: ${(props) => props.top}px;
    `};

  ${(props) =>
    props.left &&
    css`
      padding-left: ${(props) => props.left}px;
    `};

  ${(props) =>
    props.bottom &&
    css`
      padding-bottom: ${(props) => props.bottom}px;
    `};

  ${(props) =>
    props.right &&
    css`
      padding-right: ${(props) => props.right}px;
    `};
`;

export const Margin = styled.div`
  width: 100%;
  ${(props) =>
    props.margin &&
    css`
      margin: ${(props) => props.margin.replace(/( )+/g, "px ")}px;
    `};

  ${(props) =>
    props.top &&
    css`
      margin-top: ${(props) => props.top}px;
    `};

  ${(props) =>
    props.left &&
    css`
      margin-left: ${(props) => props.left}px;
    `};

  ${(props) =>
    props.bottom &&
    css`
      margin-bottom: ${(props) => props.bottom}px;
    `};

  ${(props) =>
    props.right &&
    css`
      margin-right: ${(props) => props.right}px;
    `};
`;

export const Title = styled.label`
  font-size: ${(props) => props.fontSize || (props.subtitle ? 22 : 30)}px;
  font-weight: 600;
  font-family: ${montserrat}, sans-serif !important;
  color: ${(props) => props.theme.palette[props.color || "gray"]};
  cursor: ${(props) => props.cursor || "default"};
`;

export const IconButtonStyled = styled(IconButton)`
  background-color: ${(props) =>
    props.theme.palette[props["bg-color"] || "blue"]} !important;
  color: white !important;

  .MuiSvgIcon-root {
    color: ${(props) =>
      props.theme.palette[props.iconColor || "white"]} !important;
  }

  :hover {
    background-color: ${(props) =>
      props.theme.palette[props.bghovercolor || "orange"]} !important;
  }
`;

export const DataGridDefault = styled(DataGrid)`
  .MuiDataGrid-window {
    ::-webkit-scrollbar {
      height: 13px !important;
    }

    ::-webkit-scrollbar-track {
      background-color: ${gray};
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${grayLight};
      border-radius: 20px;
    }
  }

  .MuiDataGrid-columnHeaderWrapper {
    background-color: ${gray};
    color: ${white};
    font-family: ${montserrat}, sans-serif !important;
    font-weight: bolder;
  }

  .MuiDataGrid-columnsContainer {
    min-height: 40px !important;
    max-height: 40px !important;
    line-height: 40px !important;
  }
`;

export const AccordionStyled = styled(Accordion)`
  background-color: ${(props) =>
    props.theme.palette[props["bg-color"] || "white"]};
  color: ${(props) => props.theme.palette[props.textColor || "white"]};
`;

export const GridStyled = styled(Grid)`
  ${(props) =>
    props["min-height"] &&
    css`
      min-height: ${(props) => props["min-height"]};
    `};

  ${(props) =>
    props["min-height"] &&
    css`
      min-height: ${(props) => props["min-height"]};
    `};

  ${(props) =>
    props.whiteSpace &&
    css`
      white-space: ${(props) => props.whiteSpace};
    `};

  ${(props) =>
    props.overflow &&
    css`
      overflow: ${(props) => props.overflow};
    `};

  ${(props) =>
    props.height &&
    css`
      height: ${(props) => props.height} !important;
    `};

  ${(props) =>
    props["border-radius"] &&
    css`
      border-radius: ${(props) => props["border-radius"]}px;
    `};

  ${(props) =>
    props.padding &&
    css`
      padding: ${(props) => props.padding}px!important;
    `};

  ${(props) =>
    props.margin &&
    css`
      margin: ${(props) => props.margin}px !important;
    `};

  ${(props) =>
    props["margin-bottom"] &&
    css`
      margin-bottom: ${(props) => props["margin-bottom"]}px;
    `};

  ${(props) =>
    props["line-height"] &&
    css`
      line-height: ${(props) => props["line-height"]};
    `};

  ${(props) =>
    props["box-shadow"] &&
    css`
      box-shadow: ${(props) => props["box-shadow"]};
    `};

  ${(props) =>
    props.border &&
    css`
      border: ${(props) => props.border};
    `};

  ${(props) =>
    props.borderColor &&
    css`
      border-color: ${(props) => props.theme.palette[props.borderColor]};
    `};

  ${(props) =>
    props.boxshadow &&
    css`
      box-shadow: ${(props) => props.boxshadow};
    `};

  ${(props) =>
    props.cursor &&
    css`
      cursor: ${(props) => props.cursor};
    `};

  background-color: ${(props) =>
    props.theme.palette[props["bg-color"] || "transparent"]};

  ${(props) =>
    props.bghovercolor &&
    css`
      :hover {
      }
      background-color: ${(props) => props.bghovercolor};
    `};

  ${(props) =>
    props.position &&
    css`
      position: ${(props) => props.position};
    `};

  ${(props) =>
    props.top &&
    css`
      top: ${(props) => props.top};
    `};
`;

export const LabelStyled = styled.label`
  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${(props) => props.fontSize}px;
    `};

  ${(props) =>
    props.fontFamily &&
    css`
      font-family: ${(props) => props.fontFamily};
    `};

  ${(props) =>
    props.margin &&
    css`
      margin: ${(props) => props.margin}px;
    `};

  ${(props) =>
    props.color &&
    css`
      color: ${(props) => props.theme.palette[props.color]};
    `};

  ${(props) =>
    props.fontWeight &&
    css`
      font-weight: ${(props) => props.fontWeight};
    `};

  ${(props) =>
    props.cursor &&
    css`
      cursor: ${(props) => props.cursor};
    `};

  ${(props) =>
    props["text-align"] &&
    css`
      text-align: ${(props) => props["text-align"]};
    `};
`;

export const ImgStyled = styled.img`
  ${(props) =>
    props.margin &&
    css`
      margin: ${(props) => props.margin}px;
    `};

  ${(props) =>
    props.cursor &&
    css`
      cursor: ${(props) => props.cursor};
    `};

  ${(props) =>
    props.width &&
    css`
      width: ${(props) => props.width};
    `};

  ${(props) =>
    props.height &&
    css`
      height: ${(props) => props.height};
    `};

  ${(props) =>
    props["max-width"] &&
    css`
      max-width: ${(props) => props["max-width"]};
    `};

  ${(props) =>
    props["max-height"] &&
    css`
      max-height: ${(props) => props["max-height"]};
    `};
`;

export const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxshadow: theme.shadows[2],
    fontSize: 13,
  },
}))(Tooltip);
